import { render, staticRenderFns } from "./ButtonAdminPanel.vue?vue&type=template&id=66ddf87c&scoped=true"
import script from "./ButtonAdminPanel.vue?vue&type=script&lang=js"
export * from "./ButtonAdminPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonAdminPanel.vue?vue&type=style&index=0&id=66ddf87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddf87c",
  null
  
)

export default component.exports